<div class="row">
    <div class="col">
        <label>Employee Code : {{data['business_code']}}</label>
    </div>
    <div class="col">
        <label style="font-size: 18px;font-weight: 800;">Bill Preview</label>
    </div>
    <div class="col-3" (click)="closeComponent(false)" style="text-align: right;">
        <i class="material-icons" style="cursor: pointer; font-size: 28px;">
          cancel
        </i>
      </div>
</div>
<table class="table table-bordered table-hovered">
    <thead>
        <tr>
            <th>S. No</th>
            <th>Product</th>
            <th>Count</th>
            <th>Price</th>
            <th>CGST</th>
            <th>SGST</th>
            <th>Total Price</th>
        </tr>
    </thead>
    <tbody *ngFor="let product of product_list; let product_index=index">
        <tr>
            <td>{{product_index + 1}}</td>
            <td>{{product['by_product_name']}}</td>
            <td>{{product['billing_qty']}}</td>
            <td>{{product['product_price']}}</td>
            <td>{{product['cgst_value']}}</td>
            <td>{{product['sgst_value']}}</td>
            <td>{{product['total_price']}}</td>
        </tr>
    </tbody>
</table>
<div class="row">
    <div class="col" style="font-size: 18px;font-weight: 800;">
        Total Price : {{ total_price }}
    </div>
    <div class="col">
        <button mat-button (click)="finalizeCalled()" style="background: green;color: white;">Finalize</button>
    </div>
</div>